import platformType from "@/utils/platformType";

export default {
  methods: {
    isIos() {
      return platformType.isIos();
    },
    isAndroid() {
      return platformType.isAndroid()
    }
  }
};
